var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf (3) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1_15_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4982 0H16.1987L23.5726 7.67917V22.6152C23.5726 24.4863 22.0575 26 20.1913 26H7.4982C5.62545 26 4.11035 24.4863 4.11035 22.6152V3.3848C4.11032 1.51374 5.62542 0 7.4982 0Z",
    fill: "#E5252A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1914 0V7.62069H23.5719L16.1914 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.875 19.3995V14.6504H9.89732C10.398 14.6504 10.7947 14.7868 11.0938 15.0662C11.3929 15.339 11.5425 15.7094 11.5425 16.1706C11.5425 16.6319 11.3929 17.0022 11.0938 17.2751C10.7947 17.5544 10.398 17.6909 9.89732 17.6909H9.09099V19.3995H7.875ZM9.09099 16.6579H9.76077C9.94283 16.6579 10.0859 16.6189 10.1834 16.528C10.281 16.4435 10.333 16.3266 10.333 16.1707C10.333 16.0148 10.281 15.8978 10.1834 15.8133C10.0859 15.7224 9.94286 15.6834 9.76077 15.6834H9.09099V16.6579ZM12.0432 19.3995V14.6504H13.7273C14.059 14.6504 14.3711 14.6959 14.6637 14.7933C14.9563 14.8908 15.2229 15.0272 15.457 15.2156C15.6911 15.3975 15.8797 15.6444 16.0163 15.9562C16.1463 16.2681 16.2178 16.6254 16.2178 17.0282C16.2178 17.4245 16.1463 17.7818 16.0163 18.0937C15.8797 18.4055 15.6911 18.6524 15.457 18.8343C15.2229 19.0227 14.9563 19.1591 14.6637 19.2566C14.3711 19.354 14.059 19.3995 13.7273 19.3995H12.0432ZM13.2331 18.3666H13.5843C13.7729 18.3666 13.9484 18.3471 14.111 18.3016C14.267 18.2561 14.4166 18.1846 14.5597 18.0872C14.6962 17.9898 14.8068 17.8533 14.8848 17.6714C14.9628 17.4895 15.0019 17.2751 15.0019 17.0282C15.0019 16.7748 14.9628 16.5604 14.8848 16.3785C14.8068 16.1967 14.6962 16.0602 14.5597 15.9628C14.4166 15.8653 14.2671 15.7938 14.111 15.7484C13.9484 15.7029 13.7729 15.6834 13.5843 15.6834H13.2331V18.3666ZM16.8291 19.3995V14.6504H20.2105V15.6834H18.0451V16.4435H19.7748V17.47H18.0451V19.3995H16.8291Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.86da12881d688a82f229f17ea8fd20be.svg";
export { ForwardRef as ReactComponent };